import angular from 'angular';
import moment from 'moment';

angular.module('commonServices').filter('formatTime', function() {
  return function(input) {
    // formats c# timespan to HH:mm
    return moment(input, 'HH:mm:ss').format('HH:mm');
  };
});
